<template>
  <div>
    <b-modal
      id="delete-payment-method"
      ref="delete-payment-method"
      size="entry-delete"
      centered
      hide-footer
      hide-header
      @hide="close"
    >
      <div class="modal-head">
        <span class="modal-title">{{label.get('billing_delete_payment_title')}}</span>
      </div>
      <div class="content-wrapper">
        <div class="field-row">
          <p v-html="label.get('delete_modal_body', {name: label.get('card')})" />
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="cancel atto-btn"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn delete"
          :disabled="disabled"
          @click="deleteCard"
        >
          {{ label.get('delete') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
    import BillingService from '../services/BillingService';
    export default {
        name: "DeletePaymentMethodComponent",
        props: {
            card: {
              type: Object,
              default: () => {
                return {};
              }
            }
        },
        data() {
            return {
                disabled: false
            };
        },
        mounted(){
            document.body.appendChild(this.$el);
            this.$refs['delete-payment-method'].show();
        },
        methods: {
            deleteCard(){
                this.disabled = true;
                this.$store.commit('showLoading');
                BillingService.deletePaymentMethod({ paymentMethod: this.card.pid}).then((result) => {
                    this.disabled = false;
                    this.$store.commit('hideLoading');
                    this.$awn.success(result.data.message);
                    this.$root.$emit("hideDeletePaymentMethod", this.card);
                }).catch((error) => {
                    this.disabled = false;
                    this.$store.commit('hideLoading');
                });
            },
            close(){
                this.$root.$emit("hideDeletePaymentMethod");
            }
        }
    }
</script>